import {
  AfterViewChecked,
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import { PersianNumber } from './persian-number';

@Directive({
  selector: '[mcbMoneyInput]'
})
export class MoneyInputDirective implements OnInit , AfterViewChecked {

  private regex: RegExp = new RegExp('^[0-9,.-]*$');

  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];

  @Input() myInput: any;

  constructor(private el: ElementRef, private _renderer: Renderer2) {
  }

  @HostListener('keyup', ['$event']) onKeyUp(event: KeyboardEvent) {

    let num2persian = new PersianNumber();
    let current: string = this.el.nativeElement.value;

      if (current != '') {
        let str = num2persian.Num2persian(current);
        this._renderer.setAttribute(this.el.nativeElement, 'title', str + ' ریال');
        this.el.nativeElement.value = num2persian.formatSplitter(current);
      }
  }

  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      if (this.el.nativeElement.value == ''){
        this._renderer.removeAttribute(this.el.nativeElement, 'title');
        this._renderer.removeAttribute(this.el.nativeElement, 'data-title');
        this._renderer.removeClass(this.el.nativeElement, 'invalidPersianInput');
      }
      return;
    }
    let current: string = this.el.nativeElement.value;
    let next: string = current.concat(event.key);
    if (next && !String(next).match(this.regex)) {
      this._renderer.setAttribute(this.el.nativeElement, 'title', 'تنها عدد مجاز است');
      this._renderer.addClass(this.el.nativeElement, 'invalidPersianInput');
      event.preventDefault();
    } else {
      this._renderer.removeAttribute(this.el.nativeElement, 'title');
      this._renderer.removeAttribute(this.el.nativeElement, 'data-title');
      this._renderer.removeClass(this.el.nativeElement, 'invalidPersianInput');
    }
  }

  ngOnInit() {

  }

  ngAfterViewChecked(): void {

  }
}
